var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1E2447"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6486 4.95705C13.6527 4.64806 13.5613 4.38263 13.4382 4.34619H12.8917C12.7694 4.38609 12.6813 4.61615 12.6813 4.95705C12.6813 5.29795 12.4311 15.7019 12.3076 21.0274C12.3076 21.3798 12.4552 21.6539 12.6562 21.6539H13.6894C13.8904 21.6539 14.0474 21.3798 14.038 21.0274C13.9019 15.6706 13.7721 10.3138 13.6486 4.95705Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46191 15.0769H18.5388",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03899 12.7922V13.8307H8.26976V14.523H7.34668V13.8307H7.57745V12.7922H8.03899Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07715 12.1C9.33205 12.1 9.53869 12.3066 9.53869 12.5615C9.53869 12.8164 9.33205 13.0231 9.07715 13.0231C8.90642 13.0231 8.75734 12.9304 8.6775 12.7925L6.93847 12.7923C6.85867 12.9302 6.70951 13.0231 6.53869 13.0231C6.28379 13.0231 6.07715 12.8164 6.07715 12.5615C6.07715 12.3066 6.28379 12.1 6.53869 12.1C6.70942 12.1 6.8585 12.1927 6.93834 12.3305L8.67737 12.3307C8.75717 12.1928 8.90632 12.1 9.07715 12.1Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4238 12.7922V13.8307H18.6545V14.523H17.7314V13.8307H17.9622V12.7922H18.4238Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4619 12.1C19.7168 12.1 19.9235 12.3066 19.9235 12.5615C19.9235 12.8164 19.7168 13.0231 19.4619 13.0231C19.2912 13.0231 19.1421 12.9304 19.0623 12.7925L17.3232 12.7923C17.2434 12.9302 17.0943 13.0231 16.9235 13.0231C16.6686 13.0231 16.4619 12.8164 16.4619 12.5615C16.4619 12.3066 16.6686 12.1 16.9235 12.1C17.0942 12.1 17.2433 12.1927 17.3231 12.3305L19.0621 12.3307C19.1419 12.1928 19.2911 12.1 19.4619 12.1Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1543 8.84615H17.8466",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73137 6.56152V7.59998H8.96214V8.29229H8.03906V7.59998H8.26983V6.56152H8.73137Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76953 5.86926C10.0244 5.86926 10.2311 6.0759 10.2311 6.3308C10.2311 6.5857 10.0244 6.79234 9.76953 6.79234C9.5988 6.79234 9.44972 6.69964 9.36988 6.56182L7.63085 6.56159C7.55105 6.69953 7.4019 6.79234 7.23107 6.79234C6.97617 6.79234 6.76953 6.5857 6.76953 6.3308C6.76953 6.0759 6.97617 5.86926 7.23107 5.86926C7.4018 5.86926 7.55088 5.96197 7.63072 6.09978L9.36975 6.10002C9.44955 5.96207 9.5987 5.86926 9.76953 5.86926Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7314 6.56152V7.59998H17.9621V8.29229H17.0391V7.59998H17.2698V6.56152H17.7314Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7695 5.86926C19.0244 5.86926 19.2311 6.0759 19.2311 6.3308C19.2311 6.5857 19.0244 6.79234 18.7695 6.79234C18.5988 6.79234 18.4497 6.69964 18.3699 6.56182L16.6309 6.56159C16.551 6.69953 16.4019 6.79234 16.2311 6.79234C15.9762 6.79234 15.7695 6.5857 15.7695 6.3308C15.7695 6.0759 15.9762 5.86926 16.2311 5.86926C16.4018 5.86926 16.5509 5.96197 16.6307 6.09978L18.3697 6.10002C18.4496 5.96207 18.5987 5.86926 18.7695 5.86926Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9505 16.2717L12.3076 18.925",
    stroke: "white",
    strokeWidth: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8159 10.8125L12.5518 13.4847",
    stroke: "white",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9505 21.4473L12.3076 18.925",
    stroke: "white",
    strokeWidth: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9509 16.2717L12.5518 13.4846",
    stroke: "white",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8162 10.8124L12.7334 7.6197L13.6492 4.95703",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMast);
export default __webpack_public_path__ + "static/media/map-mast.a6a67fb3.svg";
export { ForwardRef as ReactComponent };